(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/racing2/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/widgets/racing2/assets/javascripts/prescript.js');

'use strict';

svs.widget = svs.widget || {};
svs.widget.racing2 = svs.widget.racing2 || {};

 })(window);